import { cn } from "@/core/helpers/cn";

export function BankLogoColored({ className, ...props }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 166 38"
      className={cn("w-[166px] h-[38px] shrink-0", className)}
      {...props}
    >
      <path
        fill="#3BBE53"
        d="M60.45 25.23a8.72 8.72 0 0 1-4.22 1.09 7.33 7.33 0 0 1-7.6-7.56 7.33 7.33 0 0 1 7.6-7.57c1.59-.03 3.14.5 4.44 1.43L64.19 10l-.22-.23C61.93 7.94 59.19 7 56.07 7a12.5 12.5 0 0 0-8.66 3.26 11.34 11.34 0 0 0-3.4 8.35 11.88 11.88 0 0 0 3.4 8.5 12.18 12.18 0 0 0 8.63 3.36c3.52 0 6.6-1.23 8.67-3.48l-3.15-2.36-1.11.6Zm56.77-17.9v22.88h4.89v-9.36h10.4v9.36h4.9V7.33h-4.9v9.4h-10.4v-9.4h-4.89Zm-8.4 22.88h5.14l-9.55-22.88h-4.97L89.7 30.21h4.93l1.96-4.6h10.37l1.85 4.6Zm-10.75-8.43 3.78-9.17 3.56 9.17h-7.34Zm50.3-.82h3.04l7.48 9.21h6.3l-10-11.83 8.73-11.04h-5.59l-7.26 9.8h-2.7V7.3h-4.89v22.87h4.9v-9.2Zm-74.82-4.72v-5.09h12.78V7.33H68.66v22.88h10.2c5.7 0 9-2.62 9-7.19 0-4.38-2.97-6.78-8.38-6.78h-5.93Zm0 10.15v-6.33h5.12c3.1 0 4.55 1.05 4.55 3.19 0 2.13-1.52 3.18-4.55 3.18h-5.12v-.04Z"
      />
      <mask
        id="sbank-logo-colored-a"
        width="38"
        height="38"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <ellipse cx="18.76" cy="19" fill="#D9D9D9" rx="18.76" ry="19" />
      </mask>
      <g mask="url(#sbank-logo-colored-a)">
        <path
          fill="#3BBE53"
          d="M38.42 4.56a20.3 20.3 0 0 1 2.25 3.78L18.82 26.81l-7.2-5.52v-5.46l7.16 5.48L38.42 4.56Z"
        />
      </g>
      <path
        fill="url(#sbank-logo-colored-b)"
        d="M4.33 19.02c0-.26 0-.48.04-.75l-4.33-.22c0 .3-.04.63-.04.93 0 5.24 2.11 10 5.52 13.44l3.07-3.1a14.46 14.46 0 0 1-4.26-10.3Z"
      />
      <path
        fill="url(#sbank-logo-colored-c)"
        d="M18.78 4.42c.26 0 .48 0 .74.04l.22-4.38c-.3 0-.63-.04-.92-.04-5.19 0-9.9 2.13-13.3 5.58l3.07 3.1c2.6-2.65 6.22-4.3 10.19-4.3Z"
      />
      <path
        fill="url(#sbank-logo-colored-d)"
        d="M18.78 33.62c-.26 0-.49 0-.75-.04l-.22 4.38c.3 0 .63.04.93.04a18.7 18.7 0 0 0 13.3-5.58l-3.08-3.1a14.03 14.03 0 0 1-10.18 4.3Z"
      />
      <path
        fill="url(#sbank-logo-colored-e)"
        d="m26.92 6.96 3.67-2.73A18.7 18.7 0 0 0 18.78 0v4.38c3.04.04 5.85.97 8.14 2.58Z"
      />
      <path
        fill="url(#sbank-logo-colored-f)"
        d="M18.78 33.62c-4.26 0-8.08-1.87-10.7-4.83l-3.23 2.96A18.6 18.6 0 0 0 18.78 38v-4.38Z"
      />
      <path
        fill="url(#sbank-logo-colored-g)"
        d="M9.11 8.2 6.18 4.93A18.98 18.98 0 0 0 0 19.02h4.33c0-4.27 1.85-8.16 4.78-10.83Z"
      />
      <defs>
        <linearGradient
          id="sbank-logo-colored-b"
          x1="5.06"
          x2=".61"
          y1="31.89"
          y2="18.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".14" stopColor="#F2E913" />
          <stop offset=".3" stopColor="#E7E518" />
          <stop offset=".58" stopColor="#CADB26" />
          <stop offset=".89" stopColor="#A3CD39" />
        </linearGradient>
        <linearGradient
          id="sbank-logo-colored-c"
          x1="6.76"
          x2="18"
          y1="5.12"
          y2=".82"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".06" stopColor="#0FA8E0" />
          <stop offset=".54" stopColor="#0099F9" />
          <stop offset=".92" stopColor="#0291EB" />
        </linearGradient>
        <linearGradient
          id="sbank-logo-colored-d"
          x1="17.56"
          x2="30.95"
          y1="34.27"
          y2="31.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".12" stopColor="#A3CD39" />
          <stop offset=".28" stopColor="#86C339" />
          <stop offset=".87" stopColor="#21A038" />
        </linearGradient>
        <linearGradient
          id="sbank-logo-colored-e"
          x1="17.89"
          x2="29.03"
          y1="2.79"
          y2="6.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".06" stopColor="#0291EB" />
          <stop offset=".79" stopColor="#0C8ACB" />
        </linearGradient>
        <linearGradient
          id="sbank-logo-colored-f"
          x1="5.95"
          x2="17.92"
          y1="32.44"
          y2="36.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".13" stopColor="#F2E913" />
          <stop offset=".3" stopColor="#EBE716" />
          <stop offset=".53" stopColor="#D9E01F" />
          <stop offset=".8" stopColor="#BBD62D" />
          <stop offset=".98" stopColor="#A3CD39" />
        </linearGradient>
        <linearGradient
          id="sbank-logo-colored-g"
          x1="3.32"
          x2="8.13"
          y1="19.54"
          y2="6.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".07" stopColor="#A3CD39" />
          <stop offset=".26" stopColor="#81C55F" />
          <stop offset=".92" stopColor="#0FA8E0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
